function createAnimation(target, gsap, values) {
  gsap.to(target, {
    duration: 2,
    motionPath: values,
    ease: 'power1.inOut',
    onComplete: function () {
      gsap
        .timeline()
        .to(target, { duration: 0.5, ease: 'sine.out', 'z-index': 100 })
        .to(target, { duration: 0.25, ease: 'sine.out', 'z-index': 100 })
        .to(target, { duration: 0.07, display: 'none', 'z-index': 100 });
    },
  });
}

function animation1(target, gsap) {
  createAnimation(target, gsap, [
    { x: 0 - Math.random() * 5, y: -30 - Math.random() },
    { x: 0 + Math.random() * 5, y: -60 - Math.random() },
    { x: 0 - Math.random() * 5, y: -100 - Math.random() },
  ]);
}

function animation2(target, gsap) {
  createAnimation(target, gsap, [
    { x: 15 + Math.random() * 5, y: -30 - Math.random() },
    { x: -15 - Math.random() * 5, y: -50 - Math.random() },
    { x: 15 + Math.random() * 5, y: -100 - Math.random() },
  ]);
}

function animation3(target, gsap) {
  createAnimation(target, gsap, [
    { x: -25 - Math.random() * 5, y: -30 - Math.random() },
    { x: 25 + Math.random() * 5, y: -70 - Math.random() },
    { x: -25 - Math.random() * 5, y: -100 - Math.random() },
  ]);
}

function animation4(target, gsap) {
  createAnimation(target, gsap, [
    { x: -3 + Math.random() * 5, y: -30 - Math.random() },
    { x: -20 - Math.random() * 10, y: -70 - Math.random() },
    { x: 5 + Math.random() * 50, y: -100 - Math.random() },
  ]);
}

function animation5(target, gsap) {
  var val1 = -3 + Math.random() * 5;
  var val2 = 60 - Math.random() * 10;
  var val3 = 10 + Math.random() * 50;

  createAnimation(target, gsap, [
    { x: val1, y: -30 - Math.random() },
    { x: val2, y: -70 - Math.random() },
    { x: val3, y: -100 - Math.random() },
  ]);
}

async function showClapAnimation(clapEl, animationIndex) {
  const { gsap, MotionPathPlugin } = await import('gsap/all');
  gsap.registerPlugin(MotionPathPlugin);

  const animations = [animation1, animation2, animation3, animation4, animation5];

  if (animationIndex) {
    animations[animationIndex](clapEl, gsap);
  } else {
    const rand = Math.floor(Math.random() * animations.length);
    animations[rand](clapEl, gsap);
  }
}

export default showClapAnimation;
